import { FC } from 'react';

const NoDataRows: FC = () => (
    <div className="flex flex-col gap-2 w-full">
        <div className="flex-1 rounded-lg h-10 p-2 pl-4 flex flex-row justify-between items-center bg-sf-gray-0">
            <div className="flex flex-row gap-1">
                <div className="text-13 text-sf-gray-500">No data</div>
                <div className="h-6 w-6" />
            </div>
        </div>
        {Array.from({ length: 4 }, (_, index) => (
            <div
                key={index}
                className="flex-1 rounded-lg h-10 p-2 pl-4 flex flex-row justify-between items-center bg-sf-gray-0">
                <div className="flex flex-row gap-1">
                    <div className="h-4 w-32" />
                    <div className="h-6 w-6" />
                </div>
            </div>
        ))}
    </div>
);

export default NoDataRows;
